module.exports = __webpack_public_path__ + "static/media/haydarpaşa_liman.59c3c691.jpg";